import React from 'react'
import Button from '@components/Button'
import Alert from '@components/UIKit/Alert'
import LoginAtCheckout from '@page-components/Checkout/CheckoutV2/Profile/LoginAtCheckout'

import styles from './styles.module.css'

export default function Login(props) {
  const {preferences, setShowLogin} = props
  const {user, sessionEmailHasAccount} = preferences
  if (user) return null

  return (
    <div className={styles.container}>
      <div>
        <Alert description="Para continuar, ingresa tu email. Ahí recibirás la confirmación del pedido y tu boleta." />
      </div>
      <div className={styles.login}>
        <LoginAtCheckout preferences={preferences} />
      </div>
      {sessionEmailHasAccount ? (
        <div className={styles.button}>
          <Button onClick={() => setShowLogin(false)} primary>
            Continuar como invitado
          </Button>
        </div>
      ) : null}
    </div>
  )
}
